module.exports = __webpack_public_path__ + "img/logo-ivi.940ea322.svg";